export { TabBodyContentBlock } from './TabBodyContentBlock';
